// frontend/src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import { PublicClientApplication, EventType } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './authConfig';
import App from './App';
import './index.css';

const msalInstance = new PublicClientApplication(msalConfig);

// Initialize MSAL, then render the app
msalInstance.initialize().then(() => {
  // Handle redirect promise after initialization
  msalInstance.handleRedirectPromise().then((response) => {
    if (response) {
      msalInstance.setActiveAccount(response.account);
    } else {
      // Set active account if user already logged in
      const accounts = msalInstance.getAllAccounts();
      if (accounts.length > 0 && !msalInstance.getActiveAccount()) {
        msalInstance.setActiveAccount(accounts[0]);
      }
    }
  }).catch((error) => {
    console.error('Redirect handling error:', error);
  });

  // Listen for login success events
  msalInstance.addEventCallback((event) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
      msalInstance.setActiveAccount(event.payload.account);
    }
  });

  // Render the app
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </React.StrictMode>
  );
}).catch((error) => {
  console.error('MSAL initialization failed:', error);
  // Render error message
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <div style={{ padding: '40px', textAlign: 'center' }}>
      <h2>Authentication failed to initialize</h2>
      <p>Please refresh the page or contact support.</p>
      <pre style={{ color: 'red', fontSize: '12px' }}>{error.message}</pre>
    </div>
  );
});